import { createFileRoute } from "@tanstack/react-router";
import TmsDepression from "@/pages/TmsDepression";
export const Route = createFileRoute("/services/depression")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS for Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression treatment in Coral Springs, FL. SAINT TMS, standard TMS, SPRAVATO, ketamine, medication management, and therapy for depression Free consultation.",
        },
        {
          property: "og:title",
          content: "TMS for Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression treatment in Coral Springs, FL. SAINT TMS, standard TMS, SPRAVATO, ketamine, medication management, and therapy for depression Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/services/depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/services/depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsDepression />;
}
